import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import dayjs from "dayjs";
import {
  PAP_Locations_Getrow,
  PAP_Locations_Save,
} from "../../../Server/ApiV2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { fAlertToast } from "../../../Utility/Utilitys";
import SideNavToolbar from "../Components/SidenavToolbar";
import SideNavHeader from "../Components/SideNavHeader";

const ReceivedFromPrintingSideNav = ({
  open,
  onClose,
  selectedPromo,
  setSelectedPromo,
  userCd,
  pageType,
  pageTyp,
  Summary,
}) => {
  const [data, setData] = useState({});
  const [locations, setLocations] = useState([]);
  useEffect(() => {
    if (open && selectedPromo) {
      setData({
        TransId: selectedPromo.TransId || "",
        TransDate: selectedPromo.TransDate
          ? dayjs(selectedPromo.TransDate)
          : dayjs(),
        Location: selectedPromo.Location || "",
        TransLocName:
          selectedPromo.TransLocName || selectedPromo.LocationName || "",
        PromoLoc: selectedPromo.PromoLoc || "",
        PromoLocName: selectedPromo.PromoLocName || "",
        Status: selectedPromo.Status || "",
      });
    }
  }, [open, selectedPromo]);
  const getPageRows = async () => {

    const response = await PAP_Locations_Getrow({
      TransId: selectedPromo?.TransId || "",
      UserCd: userCd,
    });
    if (response?.data?.status === "Success") {
      setLocations(response?.data?.recordset ?? []);
    } else {
      setLocations([]);
      fAlertToast("FAILED", response?.data?.message || "No records found");
    }

  };

  useEffect(() => {
    if (open && selectedPromo?.TransId) getPageRows();
  }, [open]);
  const handleCheck = (RowId) => {
    setLocations((prev) =>
      prev.map((loc) =>
        loc.RowId === RowId
          ? {
            ...loc,
            [pageTyp === "Received" ? "Recieved_Status" : "Distri_Status"]:
              !(pageTyp === "Received"
                ? loc.Recieved_Status
                : loc.Distri_Status),
          }
          : loc
      )
    );
  };

  const fSave = async () => {
    const statusKey =
      pageTyp === "Received" ? "Recieved_Status" : "Distri_Status";
    const detail = locations
      .filter((x) => x[statusKey] === true)
      .map((x) => ({
        Loc: x.Loc,
      }));

    const obj = {
      TransId: selectedPromo.TransId,
      UserCd: userCd,
      Typ: pageType,
      detail,
    };

    const response = await PAP_Locations_Save(obj);

    if (response?.status === 200) {
      fAlertToast("SUCCESS", "Transaction saved successfully.");
      Summary();
      getPageRows();
      const allChecked = locations.every((x) => x[statusKey] === true);
      if (allChecked) {
        setSelectedPromo((prev) => ({
          ...prev,
          [statusKey]: "POST",
        }));
      }
    } else {
      fAlertToast("FAILED", "Save failed");
    }
  };
  const columns = [
    {
      field: "LocationName",
      headerName: "Location",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: pageTyp === "Received" ? "Recieved_Status" : "Distri_Status",
      headerName:
        pageTyp === "Received" ? "Received Status" : "Distribution Status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Checkbox
          size="small"
          checked={Boolean(
            pageTyp === "Received"
              ? params.row.Recieved_Status
              : params.row.Distri_Status
          )}
          disabled={
            pageTyp === "Received"
              ? selectedPromo?.Recieved_Status === "POST"
              : selectedPromo?.Distri_Status === "POST"
          }
          onChange={() => handleCheck(params.row.RowId)}
          sx={{
            transform: "scale(1.2)",
            padding: 0,
            cursor: "pointer",
          }}
        />
      ),
    },
    {
      field: pageTyp === "Received" ? "Recieved_ApDt" : "Distri_ApDt",
      headerName: "Appr Dt",
      flex: 1,
      headerAlign: "center",
      align: "center",
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: pageTyp === "Received" ? "Recieved_ApBy" : "Distri_ApBy",
      headerName: "Appr By",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];

  return (
    <Drawer
      anchor="right"
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 450, md: "70%" },
          overflow: "hidden",
          height: "100vh",
          borderRadius: "16px 0 0 16px",
          boxShadow: "0 4px 30px rgba(0,0,0,0.15)",
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={2.5}
        mt={5.1}
        sx={{
          position: "sticky",
          top: 1,
          zIndex: 10,
          background: "linear-gradient(135deg, #1e88e5 0%, #673ab7 100%)",
          color: "#fff",
          px: 2,
          py: 1.2,
          borderBottom: "1px solid #1565c0",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <IconButton
            edge="end"
            onClick={() => {
              onClose();
              setSelectedPromo({});
            }}
            aria-label="close"
            sx={{
              fontSize: "20px !important",
              color: "#ffffff",
              backgroundColor: "rgba(255,255,255,0.15)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.25)",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>

          <Typography
            variant="h6"
            sx={{ fontWeight: 500, marginLeft: "22px", marginTop: "4px" }}
          >
            {pageTyp === "Received" ? "Received" : "Distribution"}
          </Typography>
        </div>
        <IconButton
          onClick={() => {
            onClose();
            setSelectedPromo({});
          }}
          sx={{
            color: "#ffffff",
            backgroundColor: "rgba(255,255,255,0.15)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.25)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <SideNavToolbar
        transId={selectedPromo?.TransId || ""}
        userCd={userCd}
        selectedRow={selectedPromo}
        loadSummary={Summary}
      />
      <Box sx={{ p: 3, height: "100%" }}>
        <Box
        >
          <SideNavHeader selectedRow={selectedPromo} pageType={pageType} />
          <Box
            sx={{
              height: { xs: "calc(100vh - 330px)", md: 460 },
              width: "100%",
              mt: 3,
              overflow: "hidden",
            }}
          >
            <DataGrid
              rows={locations}
              columns={columns}
              getRowId={(row) => row.RowId}
              hideFooter
              rowHeight={36}
              sx={{
                borderRadius: 2,
                borderColor: "#e0e0e0",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f0f6ff",
                  fontWeight: "bold",
                  fontSize: 13,
                  color: "#1976d2",
                },
              }}
            />
          </Box>
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "#fff",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              borderTop: "1px solid #e0e0e0",
              zIndex: 20,
            }}
          >
            <Button
              variant="contained"
              onClick={fSave}
              disabled={
                pageTyp === "Received"
                  ? selectedPromo?.Recieved_Status === "POST"
                  : selectedPromo?.Distri_Status === "POST"
              }
              sx={{
                width: 110,
                textTransform: "none",
                fontWeight: 600,
                background: "linear-gradient(135deg, #1976d2, #42a5f5)",
                "&:hover": {
                  background: "linear-gradient(135deg, #1565c0, #2196f3)",
                },
                "&.Mui-disabled": {
                  background: "#b0b0b0",
                  color: "#ffffff",
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ReceivedFromPrintingSideNav;
